import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';
import { resetForgotPasswordPageStyles } from '../reset-forgot-password/styles';

export const ForgotPasswordPageSkeleton: React.FC = () => {
  return (
    <Box sx={{ py: 7.5 }} className="container-fluid">
      <Box sx={resetForgotPasswordPageStyles.container}>
        <Box sx={resetForgotPasswordPageStyles.card}>
          <Box>
            <Skeleton variant="circular" height="15rem" width="15rem" sx={{ mb: 4, mx: 'auto' }} />
          </Box>
          <Box sx={{ mb: 4 }}>
            <Skeleton variant="text" height="3rem" width="80%" sx={{ mx: 'auto' }} />
            <Skeleton variant="text" height="1rem" width="90%" sx={{ mx: 'auto' }} />
          </Box>
          <Box sx={{ mb: 2.5 }}>
            <Skeleton variant="text" width="10rem" />
            <Skeleton variant="rectangular" width="100%" height="2.5rem" />
          </Box>
          <Grid container spacing={2}>
            {_.times(2, _.stubArray).map((_item, index) => (
              <Grid item key={index}>
                <Skeleton variant="rectangular" height="2.5rem" width="7.5rem" />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};
